// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H76q","right":"styles_right__2NOeN"};